<template>
	<div class="w-root">
		<div class="w-views">
            <vue2-gesture-custom :type="'swipeRight'" :call="handleGesture.bind(this, 'swipeRight')">
                <div class="content-wrapper">
                    <div class="event-screen">
                        <div class="event-details event">
                            <div class="header">
                                <i class="back" @click="goBack"></i>
                            </div>

                            <div class="main-box" v-if="spot" :id="`event-${spot.id}`">
                                <div class="photo event"
                                    v-if="spot.photo_small"
                                    @click="goToPhoto(defaultPhoto)"
                                    :style="{'background': `url(${spot.photo_orig}) no-repeat center / cover`}"></div>
                                <div class="main-box-footer">
                                    <div class="inner">
                                        <div class="info" :class="{'was-online': spot.wasRecentlyOnline && !spot.isOnline, 'online': spot.isOnline && spot.type !== 'guide'}">
                                            <div class="name" v-if="!dataLoading && canViewEventDetails(spot.user_id)">
                                                {{ spot.title }}
                                            </div>
                                            <div class="notranslate">@{{spot.handle}}</div>
                                        </div>
                                        <div class="details event">
                                          <div class="location notranslate" v-if="spot.address">{{ spot.type == 'fun' || spot.type == 'bang' ? spot.locality : spot.address }}</div>
                                          <div class="location notranslate" v-else>BUDDYWOOD</div>
                                          <div class="website" v-if="spot.public_url">
                                            <a :href="getEventWebsite" target="_blank">{{ spot.public_url }}</a>
                                          </div>
                                          <div class="description" v-html="spot.description"></div>
                                          <div class="tags" v-if="spot.spot_tags && spot.spot_tags.length">
                                            <div class="tag notranslate" v-for="tag in spot.spot_tags"><span>{{ tag.name }}</span></div>
                                          </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="func-buttons bang">
                                  <button type="button"
                                          v-if="isMyEvent(spot)"
                                          @click="editSpot(spot.id, 'bang')"
                                          class="edit-button btn">
                                    {{ trans('edit') }}
                                  </button>
                                </div>
                            </div>

                        </div>

                        <div class="mobileSidebarHolder positionRight"
                            v-show="showReportMenu"
                            :class="{'active': reportMenuVisible}">
                            <div class="mobileSidebarHide" @click="hideReportMenu"></div>
                            <div class="mobileSidebar">

                                <div class="report-menu">
                                    <div class="inner">
                                        <div class="title">{{ trans('events.report.title') }}</div>
                                        <div class="box">
                                            <div class="checkbox-container">
                                                <label class="checkbox-label">
                                                    <input type="checkbox" name="wrong_category" value="wrong_category" v-model="reportData">
                                                    <span class="checkbox-custom"></span>
                                                    <div class="input-title">{{ trans('events.report.wrong_type') }}</div>
                                                </label>
                                            </div>
                                            <div class="checkbox-container">
                                                <label class="checkbox-label">
                                                    <input type="checkbox" name="under_age" value="under_age" v-model="reportData">
                                                    <span class="checkbox-custom"></span>
                                                    <div class="input-title">{{ trans('report_under_age') }}</div>
                                                </label>
                                            </div>
                                            <div class="checkbox-container">
                                                <label class="checkbox-label">
                                                    <input type="checkbox" name="illegal" value="illegal" v-model="reportData">
                                                    <span class="checkbox-custom"></span>
                                                    <div class="input-title">{{ trans('events.report.illegal') }}</div>
                                                </label>
                                            </div>
                                            <div class="checkbox-container">
                                                <label class="checkbox-label">
                                                    <input type="checkbox" name="spam" value="spam" v-model="reportData">
                                                    <span class="checkbox-custom"></span>
                                                    <div class="input-title">{{ trans('report_spam') }}</div>
                                                </label>
                                            </div>
                                        </div>
                                        <button type="submit" class="btn" @click="sendEventReport">{{ trans('send') }}</button>
                                    </div>
                                </div><!--report-menu-->

                            </div>
                        </div>
                    </div>
                </div><!--content-wrapper-->
            </vue2-gesture-custom>
		</div><!--w-views-->
	</div><!--w-root-->
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex';

    import eventsModule from '@events/module/store/type'
    import chatModule from '@chat/module/store/type'
    import "@buddy/lib/vue2-gesture-custom.js";

    export default {
        data() {
			return {
                menuVisible: false,
                reportMenuVisible: false,
                reportData: [],
			}
		},
		props: ['eventId'],
	    mixins: [
	        require('@general/lib/mixin').default,
	        require('@general/lib/mixin-events').default,
		],
		methods: {
            ...mapActions({
                reportEvent: eventsModule.actions.events.report,
                toggleEventLike: eventsModule.actions.events.like
            }),
            addLke(event){
              if(this.showJoinModalIfNeed()){
                return false;
              }
              this.toggleEventLike(event);
            },
            goBack(){
              this.$router.replace({ name: "create-event", query: {spots:1}})
            },
            openUserModal(userId) {
              this.goTo('/user/' + userId)
              //this.openUserMobileModal(userId)
            },
            handleGesture(str, e) {
                if (str == 'swipeRight')
                    this.goTo('/events')
            },
            showReportMenu() {
                this.reportMenuVisible = true;
            },
            hideReportMenu() {
                this.reportMenuVisible = false;
            },
            closeFilter() {
                this.hideReportMenu();
            },
            sendEventReport() {
                this.reportEvent({
                    reason: this.reportData,
                    id: this.spot.id,
                    callback: this.eventReportResponse,
                })
            },
            eventReportResponse(response) {
                if (response.data.success) {
                    this.showSuccessNotification(response.data.trans)
                } else {
                    this.showErrorNotification(response.data.trans)
                }
                this.closeFilter()
            },
            getProfileSettingsUrl() {
                return window.APP_URL + '/profile/settings'
			},
            openProfileSettingsUrl() {
                window.open(this.getProfileSettingsUrl(), '_system')
			},
			async chatEvent() {

        if(this.showJoinModalIfNeed()){
          return false;
        }
                if (!this.isMyEvent(this.spot)) {
					this.goTo(`/chat/event-user/${this.eventId}/${this.spot.user_id}`);
				} else {
					this.goTo('/chat');
				}
			},
            goToPhoto(photo) {
                /* too_hot */
                let isSafe = this.photoIsSafe(photo)

                if (!isSafe) {
                    return
                }

				if  (photo !== undefined) {
                    //TODO: save event profile in vuex as done for profile photos management, also pass photo details to the new component
                    this.$router.push(`/event/${this.eventId}/photo/${photo.id}`);
                }
            },
            goToVideo(video) {
                /* too_hot */
                let settingsSafe = this.userIsPro && this.$store.state.profile.app_view_sensitive_media == 'yes',
                    myEvent      = this.spot.user_id == this.$store.state.profile.id && this.$store.state.profile.id

                if (this.isApp && !settingsSafe && !myEvent) {
                    if (!this.userIsPro) {
                        this.$store.dispatch('requirementsAlertShow', 'censored')
                    } else {
                        this.$store.dispatch('requirementsAlertShow', 'change_settings')
                    }

					return
                }

                if  (video !== undefined) {
                    //TODO: save event profile in vuex as done for profile photos management, also pass photo details to the new component
                    this.$router.push(`/event/${this.eventId}/video/${video.id}`);
                }
            },
		},
        computed: {
            ...mapState({
                user: 'profile',
                userIsPro: 'userIsPro',
            }),
            ...mapGetters({
                unreadEventMessagesCount: chatModule.getters.messages.count.unreadEvent
            }),
            getEventWebsite() {
                return this.spot.public_url.startsWith('https://') || this.spot.public_url.startsWith('http://') ? this.spot.public_url : `//${this.spot.public_url}`
            },
            heartFilledIn() {
                return this.spot.isLiked
            },
            spot() {
              return this.$store.getters.getSpot(this.eventId)
            },
            dataLoading() {
                return !this.spot;
            },
            photos() {
                return this.spot && this.spot.photos && this.spot.photos.filter(v => v.pivot.is_default == 'no');
            },
            videos() {
                return this.spot && this.spot.videos;
            },
            defaultPhoto() {
                return this.spot.photos.find(v => v.pivot.is_default == 'yes');
            },
            windowHistory() {
                return window.history
            }
        },
        mounted(){
            console.log('[Event Item mobile] Mounted')
            if (!!parseInt(this.eventId)){
              this.$store.dispatch(eventsModule.actions.spot.loadInfo, {id: this.eventId, edit : 0})
              //this.$store.dispatch(eventsModule.actions.events.loadInfo, {eventId: this.eventId, edit : 0})
            }
            if (!!this.eventOriginal) {
              this.reset()
            }
        },

        activated(){
            console.log('[Event] Activated')

          }
	}
</script>
